jQuery( function( $ ) {
    $( '.brands__slider' ).slick( {
        autoplay: true,
        autoplaySpeed: 1,
        speed: 4000,
        cssEase: 'linear',
        arrows: false,
        infinite: true,
        draggable: false,
        swipe: false,
        pauseOnHover: false,
        variableWidth: true,
        // waitForAnimate: false,
    })
})